export default {
  path: '/move-warehouse',
  component: () => import('@/views/moveWarehouse/index.vue'),
  children: [
    {
      path: '',
      name: 'moveWarehouseList',
      component: () => import('@/views/moveWarehouse/pages/list.vue'),
      meta: {
        middleware: [
          'auth',
          'management',
          'developer',
          'warehouse_manager',
          'warehouse'
        ]
      }
    }
  ]
}
